/* eslint-disable no-useless-escape */
import React, { useState, useEffect } from "react";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import CustomSelectNew from "../../../components/UpdateUi/CustomeSelect";
import { Grid } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import MSelect from "react-select";
import makeAnimated from "react-select/animated";
import ConfirmationModal from "views/components/ConfirmationModal";
import InputLabel from "@material-ui/core/InputLabel";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import { textFormat } from "utils/Utils";
import FindStateData from "helper/FindState";
import { savestateData } from "store/reducers/MasterState/MasterStateSlice";
import FindStructureData from "helper/FindStructureType";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import CustomeTextField from "components/UpdateUi/CustomeTextField";
import ToastModal from "views/components/ToastModal";
import CustomTextSelect from "components/UpdateUi/CustomeTextSelect";
import { parseAndSetFlag } from "utils/Utils";
const HierarchyCreate = ({ classes }) => {
  const navigate = useNavigate();
  const params = useParams();
  const animatedComponents = makeAnimated();

  const [codeData, setCode] = useState(
    params.hierarchyId ? params.hierarchyId : ""
  );
  const code = codeData?.replace(/[^a-z0-9_]/gi, "");
  const [codeState, setCodeState] = useState(false);
  const [name, setName] = useState("");
  const [nameState, setNameState] = useState(false);
  const [rawDataDataHierarchy, setRawDataHierarchy] = useState({});
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');
  const [redirectURL, setRedirectURL] = useState("");

  const [phoneNumber, setPhoneNumber] = useState("");
  const [phoneNumberState, setPhoneNumberState] = useState(false);
  const [alternatePhoneNumber, setAlternatePhoneNumber] = useState("");
  const [alternatePhoneNumberState, setAlternatePhoneNumberState] =
    useState(false);
  const [emailAddress, setEmailAddress] = useState("");
  const [emailAddressState, setEmailAddressState] = useState(false);
  const [plotnumber, setPlotNumber] = useState("");
  const [plotnumberState, setPlotNumberState] = useState(false);
  const [pincode, setPincode] = useState("");
  const [pincodeState, setPincodeState] = useState(false);
  const [state, setState] = useState("");
  const [stateState, setStateState] = useState(false);
  const [city, setCity] = useState("");
  const [cityState, setCityState] = useState(false);
  const [defaultPincodes, setDefaultPincodes] = useState([]);
  const [pincodes, setPincodes] = useState([]);
  const [pincodesState, setPincodesState] = useState(false);

  const [structureTypeId, setStructureTypeId] = useState("");
  const [structureTypeIdState, setStructureTypeIdState] = useState(false);
  const [parentName, setParentName] = useState("");
  const [parentType, setParentType] = useState("");
  const [parentTypeState, setParentTypeState] = useState(false);
  const [editParentName, setEditParentName] = useState("");
  const [parentMasterType, setParentMasterTypeCode] = useState("");
  const [parentCode, setParentCode] = useState("");
  const [parentCodeState, setParentCodeState] = useState(false);
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  const [structureTypeList, setstructureTypeList] = useState([]);
  const [parentTypeList, setParentTypeList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [pincodesList, setPincodesList] = useState([]);
  const [branchType, setBranchType] = useState(false);
  const [isActive, setIsActive] = useState(true);
  const { stateData } = useSelector((state) => state.masterstate);
  const viewPage = window.location.href.includes('createview');
  const [productTypeList,setProductTypeList]=useState([]);
   const [selectedProductTypeCode,setSelectedProductTypeCode]=useState([]);
   const [expendedProductType, setExpandedProductType] = useState(false);
   const [isBranch,setIsBranch] = useState(false);
   const [defaultBranch,setDefaultBranch]=useState(false);
  const dispatch = useDispatch();
  const handleSelect = (selectedItems) => {
    setSelectedProductTypeCode(selectedItems);
  };
  const outletData = useOutletContext();
  const enabledDefaultBranch = parseAndSetFlag(outletData?.enabledDefaultBranch)
  const hierarchyCodeLength = outletData?.hierarchyOfficeCodeLength || 4;
  useEffect(() => {
    getPincodeList();
    (async () => {
      if (params.hierarchyId) {
        // Get Data from API
        //
        await getAllProductTypeList();
        setCallInProgress(true);
        let hierarchyDetails = await apiHandler({
          url:
            endpoint.MASTER_HIERARCHY_FIND_BY_CODE +
            params.hierarchyId?.toUpperCase(),
          authToken: authToken,
        });
        setCallInProgress(false);
        if (hierarchyDetails.data.branchType) {
          hierarchyDetails = await apiHandler({
            url:
              endpoint.MASTER_PINCODE_FIND_BY_HIERARCHY_CODE +
              params.hierarchyId,
            authToken: authToken,
          });
        }
        setCallInProgress(false);
        // Set Data to respective fields
        setIsBranch(hierarchyDetails?.data?.branchType);
        setDefaultBranch(hierarchyDetails?.data?.isDefaultBranch)
        setRawDataHierarchy(hierarchyDetails.data || "");
        setStructureTypeId(textFormat(hierarchyDetails.data.masterTypeCode) || "");
        setCode(hierarchyDetails.data.code || "");
        setName(hierarchyDetails.data.name || "");
        setPhoneNumber(hierarchyDetails.data.phoneNumber || "");
        setAlternatePhoneNumber(hierarchyDetails.data.alternatePhoneNumber || "");
        setEmailAddress(hierarchyDetails.data.email || "");
        setParentType(hierarchyDetails.data.parentCode);
        setParentCode(hierarchyDetails.data.parentCode || "");
        setEditParentName(hierarchyDetails?.data?.parentMasterTypeName || "");
        setParentMasterTypeCode(hierarchyDetails?.data?.parentMasterTypeCode || "");
        setPlotNumber(hierarchyDetails.data.address || "");
        setCity(hierarchyDetails.data.city || "");
        setState(textFormat(hierarchyDetails.data.state) || "");
        setBranchType(hierarchyDetails.data.branchType || "");
        setPincode(hierarchyDetails.data.pincode || "");
        setIsActive(hierarchyDetails.data.status === "ACTIVE" ? true : false);
        setSelectedProductTypeCode(hierarchyDetails?.data?.productType);
        if(hierarchyDetails?.data?.branchType){
          setSelectedProductTypeCode(hierarchyDetails?.data?.productType)
        }
        if(hierarchyDetails.data.parentMasterTypeCode && typeof hierarchyDetails.data.parentMasterTypeCode !== "undefined"){
          await getValidParentCode(hierarchyDetails.data.parentMasterTypeCode,hierarchyDetails.data.parentCode);
        }
        if (hierarchyDetails.data && hierarchyDetails.data.pincodes) {
          setPincodes(
            hierarchyDetails.data.pincodes &&
              hierarchyDetails.data.pincodes.map((p) => {
                return { value: p, label: p };
              })
          );
          setDefaultPincodes(
            hierarchyDetails.data.pincodes &&
              hierarchyDetails.data.pincodes.map((p) => {
                return { value: p, label: p };
              })
          );
        }
        if (
          hierarchyDetails.data.parentCode &&
          hierarchyDetails.data.parentCode.indexOf("-") !== -1
        ) {
          let index = hierarchyDetails.data.parentCode.indexOf("-");
          if (index === -1) {
            setParentType(hierarchyDetails.data.parentCode || "");
          } else {
            setParentType(hierarchyDetails.data.parentCode.substr(0, index) || "");
          }
        }
      }
    })();
  }, []);
  useEffect(() => {
    if (rawDataDataHierarchy.masterTypeCode) {
      const structureType = structureTypeList.filter(
        (z) => z.code === rawDataDataHierarchy.masterTypeCode
      );
      const parentType = structureTypeList.filter(
        (z) => z.code === rawDataDataHierarchy.parentCode
      );
      if (structureType.length > 0) {
        setStructureTypeId(textFormat(structureType[0].code));
        setStructureTypeIdState(false);
      }
      if (parentType.length > 0) {
        setParentCode(parentType[0].code);
        setParentCodeState(false);
      }
    }
  }, [structureTypeList]);

  useEffect(() => {
    if (rawDataDataHierarchy.state) {
      const selectedState = stateList.filter(
        (z) => z.name === rawDataDataHierarchy.state
      );
      if (selectedState.length > 0) {
        setState(selectedState[0].name);
        setStateState(false);
      }
    }
  }, [stateList]);

  useEffect(() => {
      FindStructureData(
        apiHandler,
        endpoint,
        authToken,
        setstructureTypeList
      );
    GetData();
  }, []);
  const GetData = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.MASTER_HIERARCHY_FINDALL,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      if(result?.data?.length < 1){
      getAllProductTypeList();
      }
    }
  };
const statusUpdate = async(checked)=>{
  const status = checked ? "ACTIVE" : "INACTIVE"
  setCallInProgress(true);
  const res = await apiHandler({
    url: endpoint.MASTER_HIERARCHY_STATUS_UPDATE,
    method: "POST",
    authToken: authToken,
    data: {
      hierarchycode:params.hierarchyId ,
      status: status
    },
  });
  setCallInProgress(false);
  if(res?.data?.error_code){
    toastUpdate("Error", res?.data?.user_description, true);
  } else{
    toastUpdate("Success", res?.data?.message, true);
    setIsActive(checked)
  }
}
  const getPincodeList = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.MASTER_PINCODE_MAPPED_UNMAPPED,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      setPincodesList(
        result?.data?.availablePincodes &&
          result?.data?.availablePincodes.map((p) => {
            return { value: p, label: p };
          })
      );
    }
  };
  useEffect(() => {
    if (!stateData.length) {
      FindStateData(
        apiHandler,
        endpoint,
        authToken,
        dispatch,
        savestateData,
        setStateList
      );
    } else {
      setStateList(stateData);
    }
  }, [stateData.length]);

  // message popup
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
      setToast(showToast);
    if (redirectURL !== "") {
      setRedirectURL("");
      navigate(redirectURL);
    }
  };
  const isEdit = !!params?.hierarchyId;
  const isCreate = !params?.hierarchyId;
  const isHeadOffice = !parentName || parentName.length === 0;
  console.log(params?.hierarchyId,parentName,"fsdkfbkas")
  const isValidated = () => {
    if (code === "") {
      setCodeState(true);
    } else {
      setCodeState(false);
    }
    if (name === "") {
      setNameState(true);
    } else {
      setNameState(false);
    }
    if (phoneNumber === "" && phoneNumber.length!==10) {
      setPhoneNumberState(true);
    } else {
      setPhoneNumberState(false);
    }
    if (alternatePhoneNumber === "" && alternatePhoneNumber.length!==10) {
      setAlternatePhoneNumberState(true);
    } else {
      setAlternatePhoneNumberState(false);
    }
    if (emailAddress === "") {
      setEmailAddressState(true);
    } else {
      setEmailAddressState(false);
    }
    if (plotnumber === "") {
      setPlotNumberState(true);
    } else {
      setPlotNumberState(false);
    }
    if (city === "") {
      setCityState(true);
    } else {
      setCityState(false);
    }
    if (pincode === "" && pincode.length!==6) {
      setPincodeState(true);
    } else setPincodeState(false);
    if (state === "") {
      setStateState(true);
    } else setStateState(false);
    if (structureTypeId === "") {
      setStructureTypeIdState(true);
    } else {
      setStructureTypeIdState(false);
    }
   if (isCreate && !isHeadOffice && !parentType) {
      setParentTypeState(true);
    } else {
      setParentTypeState(false);
    }
    const isParentValid =
      isEdit ||
      isHeadOffice ||
      parentType;

    if (
      code &&
      name &&
      phoneNumber.length===10 &&
      alternatePhoneNumber.length===10 &&
      emailAddress &&
      plotnumber &&
      city &&
      pincode.length=== 6 &&
      state &&
      structureTypeId &&
      isParentValid
    ) {
      return true;
    } else {
      return false;
    }
  };
  const stateCode = (stateList || [])?.filter(
    (item) => item.code === state?.toUpperCase()
  );
  const editHierarchyInformation = async () => {
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.MASTER_HIERARCHY_UPDATE,
      method: "PUT",
      authToken: authToken,
      data: {
        code: code?.toUpperCase(),
        name: name,
        phoneNumber: phoneNumber,
        alternatePhoneNumber: alternatePhoneNumber,
        email: emailAddress?.toLowerCase(),
        address: plotnumber,
        state: stateCode?.[0]?.code?.toUpperCase(),
        city: city,
        pincode: pincode,
        id: rawDataDataHierarchy.id,
        masterTypeCode: structureTypeId?.toUpperCase(),
        parentCode: parentType !== "none" ? parentType?.toUpperCase() : "",
        parentMasterTypeCode:
          parentType !== "none" ? parentType?.toUpperCase() : "",
        parentMasterTypeName:
        parentCodes?.[0]?.name || editParentName,
        pincodes: pincodes?.map((p) => p?.value),
        productType: selectedProductTypeCode,
        defaultBranch:defaultBranch,
      },
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
      return "ERROR";
    } else {
      return "SUCCESS";
    }
  };
  const saveHierarchyInformation = async () => {
    setCallInProgress(true);
    const bulkData = {
      code: code?.toUpperCase(),
      name: name,
      phoneNumber: phoneNumber,
      alternatePhoneNumber: alternatePhoneNumber,
      email: emailAddress?.toLowerCase(),
      address: plotnumber,
      state: stateCode?.[0]?.code,
      city: city,
      pincode: pincode,
      masterTypeCode: structureTypeId?.toUpperCase(),
      parentCode: parentType !== "none" ? parentType?.toUpperCase() : "",
      parentMasterTypeCode:
        parentType !== "none" ? parentType?.toUpperCase() : "",
      parentMasterTypeName: parentCodes?.[0]?.name || editParentName,
      pincodes: pincodes?.map((p) => p?.value),
      productType: selectedProductTypeCode,
      defaultBranch:defaultBranch
    };
    const res = await apiHandler({
      url: endpoint.MASTER_HIERARCHY_ADD,
      method: "POST",
      authToken: authToken,
      data: bulkData,
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      if (res?.data?.error_code === 409) {
        toastUpdate("Error","Same Office Code Exists", true);
      } else {
        toastUpdate("Error", res?.data?.user_description, true);
      }
      return "ERROR";
    } else {
      return "SUCCESS";
    }
  };

  const handlehierarchySubmit = async (event) => {
    if (isValidated()) {
      toastUpdate("", "", false);

      let status = "";
      if (params.hierarchyId) {
        status = await editHierarchyInformation();
      } else {
        status = await saveHierarchyInformation();
      }

      if (branchType) {
        // check for linked and unlinked pincodes
        let linkedPincodes = [],
          unlinkPincodes = [];
        defaultPincodes.forEach((dp) => {
          if (pincodes.find((p) => p.value === dp.value)) {
            // empty
          } else {
            unlinkPincodes.push(dp);
          }
        });
        pincodes.forEach((p) => {
          if (defaultPincodes.find((dp) => p.value === dp.value)) {
            // empty
          } else {
            linkedPincodes.push(p);
          }
        });
        if (status === "SUCCESS" && unlinkPincodes.length > 0) {
          status = await unlinkAllocatedPincodes(
            unlinkPincodes.map((p) => p.value)
          );
        }
      }
      if (status === "SUCCESS") {
        const msg = params.hierarchyId
          ? "Hierarchy updated successfully!"
          : "Hierarchy created successfully!";
          toastUpdate("Success", msg, true);
        setRedirectURL(`/coreservice/hierarchy`);
      }
    }
  };
  const getMasterParentCode = async (code) => {
    const parentCodes = (structureTypeList || [])?.filter(
      (item) => item.code === code?.toUpperCase()
    );
    if (parentCodes?.[0]?.parentCode) {
      setBranchType(false);
      if(parentCodes?.[0]?.branchType){
        setBranchType(true);
        setIsBranch(true);
        getAllProductTypeList();
      }
      getValidParentCode(parentCodes?.[0]?.parentCode);
    }
  };
  const getAllProductTypeList = async (type) => {
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.FIND_ALL_PRODUCT_TYPE,
      method: "GET",
      authToken: authToken,
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
      return;
    } else {
      if(type){
        return res?.data;
      }else{
        setProductTypeList(res?.data);
      }
    }
  }
  const getValidParentCode = async (code,parentCode) => {
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.MASTER_HIERARCHY_FIND_BY_TYPE_CODE + code?.toUpperCase(),
      method: "GET",
      authToken: authToken,
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
      return;
    } else {
      setParentName(res?.data);
      setParentTypeList(res?.data);
      if(parentCode) {
        setParentType(textFormat(parentCode));
      }
    }
  };
  const unlinkAllocatedPincodes = async (unavaliableTemplist) => {
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.MASTER_HIERARCHY_PINCODE_DELINK,
      method: "POST",
      authToken: authToken,
      data: {
        pincodes: [...unavaliableTemplist],
        hierarchyCode: code?.toUpperCase(),
      },
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
      return "ERROR";
    } else {
      return "SUCCESS";
    }
  };
  const parentCodes = (parentName || [])?.filter(
    (item) => item.code === parentType?.toUpperCase()
  );

  const handleParentCode = async (e) => {
    setParentType(e);
  }
  const handleCancelHierarchy = () => {
    navigate("/coreservice/hierarchy");
  };
  const getSelectedPincodeList = () => [...pincodes];
  const getCompletePincodeList = () => [...defaultPincodes, ...pincodesList];
  const keyPress = (e) => {
    if (e.target.value.length > 9) {
      e.preventDefault();
      return false;
    }
  };

  const onBlurError = (e, type) => {
    if (
      (e && e.length < 6 && type === "pincode") ||
      (e.length > 6 && type === "pincode")
    ) {
      setPincodeState(true);
    }
    if (e && e.length === 6 && type === "pincode") {
      setPincodeState(false);
    }

    if (
      (e && e.length < 10 && type !== "pincode") ||
      (e.length > 10 && type !== "pincode")
    ) {
      
      if (type === "mobileNumber") {
        setPhoneNumberState(true);
      } else {
        setAlternatePhoneNumberState(true);
      }
    } else {
      if (type === "mobileNumber") {
        setPhoneNumberState(false);
      } else {
        setAlternatePhoneNumberState(false);
      }
    }
  };
  const changeMasterTyoe = (event) => {
    setParentType('');
    setParentName('');
    getMasterParentCode(event);
    setStructureTypeId(event);
  };
  const title = viewPage ? "View Hierarchy Office" : "Edit Hierarchy Office";
  const regex = /^[0-9\b]+$/;
  const handleChange = (e) => {
    if (e === "" || regex.test(e)) {
      setPhoneNumber(e);
    }
  };
  const handleChange2 = (e) => {
    if (e === "" || regex.test(e)) {
      setAlternatePhoneNumber(e);
    }
  };
  const handleChange1 = (e) => {
    if (e === "" || regex.test(e)) {
      setPincode(e);
    }
  };
  return (
      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
          <SubHeader
            label={
              params.hierarchyId
              ? title
                : "Create Hierarchy Office"
            }
            button1={!viewPage && "Save"}
            button2=" Cancel"
            button1click={!viewPage && handlehierarchySubmit}
            button2click={handleCancelHierarchy}
          />
        </Grid>

      <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
        <Grid container className={classes.inputFieldContainer}>
          <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
            <CustomSelectNew
              label="Master Type Name*"
              id="master_type_name"
              error={structureTypeIdState}
              value={structureTypeId}
              setState={changeMasterTyoe}
              data={structureTypeList}
              setError={setStructureTypeIdState}
              disabled={!!params.hierarchyId || viewPage}
            />
          </Grid>
         <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Office Code"
              required
              error={codeState}
              id="lp_hierachy_code"
              type="code"
              value={code?.toUpperCase() || ""}
              setState={setCode}
              maxLength={Number(hierarchyCodeLength)}
              setError={setCodeState}
              disabled={!!params.hierarchyId || viewPage}
            />
          </Grid>
         <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Office Name"
              required
              error={nameState}
              id="lp_hierachy_name"
              value={name || ""}
              setState={setName}
              setError={setNameState}
              disabled={viewPage}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Office Phone Number"
              required
              error={phoneNumberState}
              id="lp_hierachy_phone_number"
              value={phoneNumber || ""}
              setState={handleChange}
              maxLength="10"
              setBlur={onBlurError}
              blurLabel="mobileNumber"
              disabled={viewPage}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Alternate Phone Number"
              required
              error={alternatePhoneNumberState}
              id="lp_hierachy_alternamephonenumber"
              value={alternatePhoneNumber || ""}
              setState={handleChange2}
              maxLength="10"
              setBlur={onBlurError}
              blurLabel="alternateNumber"
              disabled={viewPage}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Email Address"
              error={emailAddressState}
              required
              id="lp_hierachy_emailaddress"
              value={emailAddress?.toLowerCase() || ""}
              setState={setEmailAddress}
              setError={setEmailAddressState}
              type="notCapital"
              disabled={viewPage}
            />
          </Grid>
        { Array.isArray(parentName) && parentName.length > 0 && (
          <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
              <CustomSelectNew
                label="Parent Code*"
                error={parentTypeState}
                id="lp_hierachy_parentcode"
                value={parentType}
                setState={handleParentCode}
                data={parentName}
                setError={setParentTypeState}
                disabled={!structureTypeId || viewPage}
                type="hierarchyCode"
              />
          </Grid>
        )}
          <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Parent Master Type Name"
              required
              id="lp_hierachy_parent_name"
              value={parentCodes?.[0]?.name || editParentName}
              disabled
            />
          </Grid>
          {isBranch &&
            <Grid
              item
              xs={12}
              sm={12}
              md={4}
              className={classes.fieldContaienr}
            >
            <CustomTextSelect
              label="Seach Product Type..."
              data={productTypeList}
              onSelect={handleSelect}
              selectedBranchCodes={selectedProductTypeCode}
              initiallyExpanded={expendedProductType}
              disabled={viewPage}
              />
            </Grid>
          }
          {(isBranch && enabledDefaultBranch) &&
            <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
               <label style={{ display:"flex", alignItems:'center', color:'black', gap:'20px', fontSize:'16x' }}> 
               {" "}
               <input
                 style={{ marginTop: 2, width:'30px', height:'30px' }}
                 id="selectAll"
                 type="checkbox"
                 checked={defaultBranch}
                 className={classes.checkboxInput}
                 onChange={(e) => setDefaultBranch(e.target.checked)}
               />{" "}
               Default Branch
             </label>
            </Grid>
          }
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            className={classes.inputFieldContainer}
          >
            <h2 className={classes.header}>Office Address</h2>
          </Grid>
         <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Address"
              required
              error={plotnumberState}
              id="lp_hierachy_plotnumber"
              value={plotnumber || ""}
              setState={setPlotNumber}
              setError={setPlotNumberState}
              disabled={viewPage}
            />
          </Grid>
         <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="City"
              required
              error={cityState}
              id="lp_hierachy_city"
              value={city || ""}
              setState={setCity}
              setError={setCityState}
              disabled={viewPage}
            />
          </Grid>
         <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Pincode"
              required
              error={pincodeState}
              id="lp_hierachy_pincode"
              value={pincode || ""}
              maxLength="6"
              setBlur={onBlurError}
              blurLabel="pincode"
              setState={handleChange1}
              // setError={setPincodeState}
              disabled={viewPage}
            />
          </Grid>
         <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomSelectNew
              label="State*"
              error={stateState}
              value={state}
              setState={setState}
              data={stateList}
              setError={setStateState}
              disabled={viewPage}
            />
          </Grid>
           <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
              <p style={{ fontWeight: "bold",display:"flex", alignItems:"center",margin:"0" }}>
                {" "}
                <input
                  id="selectAll"
                  type="checkbox"
                  checked={isActive}
                  style={{ marginTop: 2, width:'30px', height:'30px' }}
                  className={classes.checkboxInput}
                  onChange={(e) => statusUpdate(e.target.checked)}
                  disabled={viewPage || !params.hierarchyId}
                />{" "}
                Active
              </p>
            </Grid>
          {(branchType) && (
            <>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                className={classes.inputFieldContainer}
              >
                <h2 className={classes.header}>Linked Pincodes</h2>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                className={classes.inputContainer}
              >
                <Grid container className={classes.inputFieldContainer}>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={4}
                    className={classes.fieldContaienr}
                  >
                    <InputLabel>Pincodes*</InputLabel>
                    <MSelect
                      closeMenuOnSelect={false}
                      components={animatedComponents}
                      value={getSelectedPincodeList()}
                      isMulti
                      isDisabled={viewPage}
                      onChange={(e) => {
                        !viewPage &&  setPincodes(e);
                      }}
                      options={getCompletePincodeList()}
                    />
                  </Grid>{" "}
                </Grid>{" "}
              </Grid>
            </>
          )}
        </Grid>
      </Grid>
      {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
      </Grid>
  );
};

export default HierarchyCreate;
